import theme from '@styles';
import {hirist, iimjobs} from './app/layout';

export type MetaElement = {
  siteName: string;
  locale: string;
  gaTagId: string;
  gaManagerId: string;
  fontFamily: string;
  theme: object;
  app: {
    [key: string]: object;
  };
};

export interface MetaType<TValue> {
  [key: string]: TValue;
}

export const metaInfo: MetaType<MetaElement> = {
  iimjobs: {
    siteName: 'iimjobs.com',
    locale: 'en',
    gaTagId: 'UA-2175565-2',
    gaManagerId: 'GTM-5JSBZG7',
    fontFamily:
      'https://fonts.googleapis.com/css2?family=Abhaya+Libre:wght@400;500;600;700&family=Poppins:wght@300;400;500;600&display=swap',
    theme: theme['iimjobs'],
    app: iimjobs,
  },
  hirist: {
    siteName: 'hirist.tech',
    locale: 'en',
    gaTagId: 'UA-33517701-1',
    //gaManagerId: 'GTM-WCRJPZQ',
    gaManagerId: 'GTM-KMWNCD3M',
    fontFamily:
      'https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap',
    theme: theme['hirist'],
    app: hirist,
  },
};
